<template>
  <div class="modal fade">
    <v-dialog :value="value" @input="$emit('input')" width="400">
      <v-layout>
        <v-flex xs12>
          <v-card>
            <v-toolbar dense class="elevation-2">
              <v-spacer></v-spacer>
              <v-toolbar-title>Reset Password</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon>
                <v-icon @click="closeModal">close</v-icon>
              </v-btn>
            </v-toolbar>
          <v-card-text>
            <!-- Alert error message -->
            <div class="col-md-12" v-show="errorMessage && errorMessage !== null" >
              <b-alert dismissible variant="danger">
                <p>{{errorMessage}}</p>
              </b-alert>
            </div>
            <!-- Alert error message -->
            <form>
              <v-container class="remove-padding" container--fluid>
                <v-layout row wrap>
                  <v-flex xs12 sm12>
                    <label class="mt-3">Generate a strong password</label>
                    <div class="d-flex flex-row justify-space-between">
                      <span style="font-weight:500;padding-top:6px;">{{generatedPass}}</span>
                      <div>
                        <v-btn @click="copyPass()" icon>
                          <v-icon small>mdi-content-copy</v-icon>
                        </v-btn>
                        <v-btn @click="generatePass()" icon>
                          <v-icon small>mdi-reload</v-icon>
                        </v-btn>
                      </div>
                    </div>
                    <label class="mt-3">Set Password</label>
                    <div class="d-flex flex-row">
                      <v-text-field
                        v-model="user.newPassword"
                        @input="$v.user.newPassword.$touch()"
                        @blur="$v.user.newPassword.$touch()"
                        :error-messages="passwordError"
                        type="text"
                        autocomplete="new-password"
                        name="new-password"
                        color="#1687c0"
                        label=""
                        class="input-group--focused mt-0 pt-0"
                        @click:append="show.password = !show.password"
                      ></v-text-field>
                    </div>
                  </v-flex>
                </v-layout>
              </v-container>
            </form>
          </v-card-text>
          <v-card-actions>
            <v-btn text @click="closeModal">Close</v-btn>
            <v-spacer></v-spacer>
            <v-btn text
              color="secondary"
              :disabled="$v.user.$invalid"
              @click="changePassword"
            >Save</v-btn>
          </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
      <input type="hidden" id="copy-pass" :value="generatedPass">
    </v-dialog>
  </div>
</template>
<script>
import userAPIs from './userAPIs';
import { required } from 'vuelidate/lib/validators';
import utils from '@/utils';
// import { regex } from 'vuelidate/lib/validators/common';
// import config from '../../../config';

export default {
  name: 'InfResetPasswordModal',
  props: {
    value: Boolean,
    influencer: Object
  },
  data() {
    return {
      user: {},
      generatedPass: '',
      errorMessage: null,
      show: {
        password: false
      }
    };
  },
  watch: {
    // userData: function (newUserData) {
    //   this.user = newUserData
    // }
    influencer: function (newInfluencerData) {
      this.user = {
        newPassword: ''
      };
      this.generatePass()
    }
  },

  computed: {
    passwordError() {
      const errors = [];
      if (!this.$v.user.newPassword.$dirty) return errors;
      !this.$v.user.newPassword.required && errors.push('Password is required.')
      return errors;
    }
  },

  validations: {
    user: {
      newPassword: {
        required
      }
    }
  },
  methods: {
    closeModal: function() {
      this.$emit('input')
    },
    changePassword: function() {
      this.$swal({
        title: 'Double Check!',
        text: `Are you sure you want to reset password for ${this.influencer.email}`,
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(result => {
        // Update submitting status
        if (result.value) {
          this.errorMessage = null;
          const editingInfo = {
            influencerID: this.influencer.id,
            email: this.influencer.email,
            password: this.user.newPassword
          };
          // Reset password
          userAPIs
            .resetInfPassword(editingInfo)
            .then(response => {
              // Return the newly added data to parent component
              this.$emit('reload', response);
              // Dismiss modal by triggering the click event on Close button
              this.closeModal()
              this.$swal({
                html: `Please save a copy of users credentials.<br><br>
                <b>${this.influencer.email}</b><br>
                <b>${this.user.newPassword}</b><br><br>
                <i style='font-size:13px'>Once confirmed, this password will no longer be visible</i>`,
                type: 'success'
              })
            })
            .catch(error => {
              // Request failed.
              this.errorMessage = error.response.data.message;
              console.log('error.response', error.response);
              console.log('error.response.data', error.response.data);
              console.log('error', error.response.data.message);
            });
        }
      })
    },
    copyPass() {
      setTimeout(function() { utils.func.copyToClipboard('#copy-pass') }, 100)
      this.password = this.generatedPass
    },
    generatePass: function() {
      this.generatedPass = utils.func.generatePassword()
    },
    clearData: function() {
      this.user = {
        newPassword: ''
      };
    }
  },
  mounted: function() {
    this.user = {
      newPassword: ''
    };
  }
};
</script>

<style>
.password-errors {
  display: block;
  margin-top: 1em;
  margin-bottom: 1 em;
  margin-left: 0;
  margin-right: 0;
  padding-left: 40px;
}
.primary--text {
  color: #1687c0 !important;
  caret-color: #1687c0 !important;
}

.modal-body {
  padding: 0px 25px !important;
}

.remove-padding {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}

.error--text {
  color: #d65849c7 !important;
  caret-color: #d65849c7 !important;
}
/* .v-messages__wrapper {
  color: #1687c0
} */
ul > li {
  list-style-type: square;
}
li.error-message {
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// InfResetPasswordModal.vue?fc93ce52